var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ethers, BigNumber } from 'ethers';
import { ChainId, GasSetting, PUBLIC_RPCS } from '../../config/networks';
import { calculateGasSettings } from '../../quoting-engine/uniswap/execution/gasSettings';
/**
 * Executes a series of direct transactions using the provided wallet and gas settings.
 *
 * @param {IExecuteQuote} params - The parameters for executing the transactions.
 * @param {Array<ITransaction>} params.transactions - The list of transactions to execute.
 * @param {Wallet | PKPEthersWallet} params.wallet - The wallet to use for signing and sending the transactions.
 * @param {ChainId} params.network - The network on which the transactions will be executed.
 * @param {GasSetting} [params.gasSetting=GasSetting.MARKET] - The gas setting to use (default is Market).
 * @returns {Promise<Array<ethers.providers.TransactionReceipt>>} - A promise that resolves to an array of transaction receipts.
 *
 * @throws {Error} - Throws an error if there is an issue calculating gas settings or sending the transactions.
 */
export function executeDirectTransactionsEVM(_a) {
    return __awaiter(this, arguments, Promise, function (_b) {
        var RPC_URL, provider, nonce, gasSettings, isEIP1559, error_1, txPromises, txResponses, txResponsesWithHash, receiptPromises, error_2;
        var _this = this;
        var transactions = _b.transactions, wallet = _b.wallet, network = _b.network, _c = _b.gasSetting, gasSetting = _c === void 0 ? GasSetting.MARKET : _c, blockConfirmations = _b.blockConfirmations, legacyPayloads = _b.legacyPayloads;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    RPC_URL = PUBLIC_RPCS[network];
                    provider = new ethers.providers.JsonRpcProvider(RPC_URL);
                    console.log('Executing order legacyPayloads', legacyPayloads);
                    return [4 /*yield*/, provider.getTransactionCount(wallet.address, 'pending')];
                case 1:
                    nonce = _d.sent();
                    if (!!(legacyPayloads === null || legacyPayloads === void 0 ? void 0 : legacyPayloads.length)) return [3 /*break*/, 5];
                    _d.label = 2;
                case 2:
                    _d.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, calculateGasSettings({
                            network: network,
                            transactions: transactions,
                            gasSetting: network === ChainId.ETHEREUM ? GasSetting.MARKET : GasSetting.MARKET,
                        })];
                case 3:
                    gasSettings = _d.sent();
                    isEIP1559 =
                        gasSettings.maxFeePerGas !== undefined && gasSettings.maxPriorityFeePerGas !== undefined;
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _d.sent();
                    console.log('Executing order Error calculating gas settings:', error_1);
                    throw error_1;
                case 5:
                    txPromises = transactions.map(function (tx, i) { return __awaiter(_this, void 0, void 0, function () {
                        var txRequest, gasPrice, gasLimit, blockBaseFee, arbitrumMinGasLimit, signedTx, result, error_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    _a.trys.push([0, 7, , 8]);
                                    txRequest = {
                                        to: tx.to,
                                        value: tx.value ? BigNumber.from(tx.value) : undefined,
                                        data: tx.data,
                                        nonce: nonce + i,
                                        chainId: provider.network.chainId, // Explicitly set chainId
                                    };
                                    if (!(legacyPayloads === null || legacyPayloads === void 0 ? void 0 : legacyPayloads.length)) return [3 /*break*/, 3];
                                    console.log('Executing order maxFeePerGas', legacyPayloads[i]);
                                    gasPrice = BigNumber.from(legacyPayloads[i].gasPrice);
                                    gasLimit = BigNumber.from(legacyPayloads[i].gasLimit);
                                    if (!(network === ChainId.ARBITRUM)) return [3 /*break*/, 2];
                                    return [4 /*yield*/, provider.getGasPrice()];
                                case 1:
                                    blockBaseFee = _a.sent();
                                    // Increase gasPrice to be slightly above block base fee
                                    gasPrice = blockBaseFee.mul(120).div(100); // 10% higher than base fee
                                    arbitrumMinGasLimit = 2000000;
                                    gasLimit = BigNumber.from(legacyPayloads[i].gasLimit).gt(arbitrumMinGasLimit)
                                        ? BigNumber.from(legacyPayloads[i].gasLimit)
                                        : BigNumber.from(arbitrumMinGasLimit);
                                    console.log('Executing order Adjusted gas settings for Arbitrum:', {
                                        gasPrice: gasPrice.toString(),
                                        gasLimit: gasLimit.toString(),
                                    });
                                    _a.label = 2;
                                case 2:
                                    txRequest = __assign(__assign({}, txRequest), { gasPrice: gasPrice, gasLimit: gasLimit, type: 1 });
                                    return [3 /*break*/, 4];
                                case 3:
                                    if (isEIP1559) {
                                        txRequest = __assign(__assign({}, txRequest), { maxFeePerGas: BigNumber.from(gasSettings.maxFeePerGas), maxPriorityFeePerGas: BigNumber.from(gasSettings.maxPriorityFeePerGas), type: 2 });
                                    }
                                    else {
                                        txRequest = __assign(__assign({}, txRequest), { gasPrice: BigNumber.from(gasSettings.gasPrice), type: 1 });
                                    }
                                    _a.label = 4;
                                case 4:
                                    // Set gas limit
                                    if (!(legacyPayloads === null || legacyPayloads === void 0 ? void 0 : legacyPayloads.length)) {
                                        txRequest.gasLimit = BigNumber.from(gasSettings.gasEstimations[i]);
                                    }
                                    console.log('Executing order txRequest', txRequest);
                                    return [4 /*yield*/, wallet.signTransaction(txRequest)];
                                case 5:
                                    signedTx = _a.sent();
                                    return [4 /*yield*/, provider.sendTransaction(signedTx)];
                                case 6:
                                    result = _a.sent();
                                    console.log('Executing order result', result);
                                    return [2 /*return*/, result];
                                case 7:
                                    error_3 = _a.sent();
                                    console.error('Executing order result Error sending transaction:', error_3);
                                    throw error_3;
                                case 8: return [2 /*return*/];
                            }
                        });
                    }); });
                    _d.label = 6;
                case 6:
                    _d.trys.push([6, 9, , 10]);
                    return [4 /*yield*/, Promise.all(txPromises)];
                case 7:
                    txResponses = _d.sent();
                    // Wait for all transactions to be mined
                    console.log('Executing order txResponses', txResponses, blockConfirmations);
                    txResponsesWithHash = txResponses.map(function (tx, i) {
                        return __assign({ transactionHash: tx.hash }, tx);
                    });
                    console.log('Executing order txResponsesWithHash', txResponsesWithHash, blockConfirmations);
                    receiptPromises = void 0;
                    if (blockConfirmations == 0) {
                        //@ts-ignore
                        return [2 /*return*/, txResponsesWithHash];
                    }
                    if (blockConfirmations) {
                        receiptPromises = txResponses.map(function (tx) { return tx.wait(blockConfirmations); });
                    }
                    else {
                        receiptPromises = txResponses.map(function (tx) { return tx.wait(); });
                    }
                    return [4 /*yield*/, Promise.all(receiptPromises)];
                case 8: return [2 /*return*/, _d.sent()];
                case 9:
                    error_2 = _d.sent();
                    console.error('Error sending transactions:', error_2);
                    throw error_2;
                case 10: return [2 /*return*/];
            }
        });
    });
}
